import NiceModal from '@ebay/nice-modal-react';

import { useContext, useEffect, useMemo, useTransition } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import Loading from 'components/global/Loading';

import useAccessControl from 'hooks/useAccessControl';

import ActionRoleModal from 'pages/Admin/AccessControl/ActionRoleModal';
import RoleModal from 'pages/Admin/AccessControl/RoleModal';
import UpdateMultipleCountriesModal from 'pages/Admin/AccessControl/UpdateMultipleCountriesModal';
import UpdateMultipleModuleModal from 'pages/Admin/AccessControl/UpdateMultipleModuleModal';
import UpdateMultipleRoleModal from 'pages/Admin/AccessControl/UpdateMultipleRoleModal';
import RoleTreeModal from 'pages/Admin/RoleTree/RoleTreeModal';
import AutomationForm from 'pages/Automation/AutomationForm';
import BranchForm from 'pages/Branches/BranchForm';
import CODReportModal from 'pages/FinanceUser/CODPayable/CODPayable/CODReportModal';
import AddImportOrderModal from 'pages/ImportOrders/AddImportOrderModal';
import EditImportOrderModal from 'pages/ImportOrders/EditImportOrderModal';
import ViewImportOrderModal from 'pages/ImportOrders/ViewImportOrderModal';
import AddTransactionForm from 'pages/OTOFlexMain/Drivers/AddTransactionForm';
import DriverForm from 'pages/OTOFlexMain/Drivers/DriverForm';
import DriverTrackForm from 'pages/OTOFlexMain/Drivers/DriverTrackForm';
import OrderOtomationForm from 'pages/OrderOtomation/OrderOtomationForm';
import AttributesGroupForm from 'pages/Products/AttributesGroups/AttributesGroupForm';
import ProductAttributesForm from 'pages/Products/ProductAttributes/ProductAttributesForm';
import ProductSpecsModal from 'pages/Products/ProductSpecsModal';
import ProductForm from 'pages/Products/Products/ProductForm';
import RoleTemplatesModal from 'pages/RoleTemplates/RoleTemplatesModal';
import AreaSettingForm from 'pages/Settings/Area/AreaSettings/AreaSettingForm';
import CityGroupForm from 'pages/Settings/Area/CityGroup/CityGroupForm';
import BlacklistedCustomerForm from 'pages/Settings/BlacklistedCustomers/BlacklistedCustomerForm';
import BoxForm from 'pages/Settings/Box/BoxForm';
import BrandForm from 'pages/Settings/Brands/BrandForm';
import CustomizablePageForm from 'pages/Settings/CustomizablePages/CustomizablePageForm';
import EmailAccountForm from 'pages/Settings/Email/EmailAccounts/EmailAccountForm';
import EmailSettingForm from 'pages/Settings/Email/EmailSettings/EmailSettingForm';
import PredefinedMessageForm from 'pages/Settings/ReasonConfig/PredefinedMessageForm';
import ReasonConfigForm from 'pages/Settings/ReasonConfig/ReasonConfigForm';
import FreeTrackingSmsForm from 'pages/Settings/SMS/FreeTrackingSmsForm';
import SMSSettingForm from 'pages/Settings/SMS/SMSSettingForm';
import AddPriceForm from 'pages/Settings/ShippingPrices/ShippingPrices/AddPriceForm';
import WhatsappSettingForm from 'pages/Settings/Whatsapp/WhatsappSettings/WhatsappSettingForm';
import WhatsappTemplateForm from 'pages/Settings/Whatsapp/WhatsappTemplates/forms/WhatsappTemplateForm';
import CreateReturnShipmentAggregator from 'pages/Shipments/ActionForms/CreateShipment/CreateReturnShipmentAggregator';
import CreateReturnShipmentWithMyRates from 'pages/Shipments/ActionForms/CreateShipment/CreateReturnShipmentWithMyRates';
import CreateShipmentBulkAggregatorModal from 'pages/Shipments/ActionForms/CreateShipment/CreateShipmentBulkAggregatorModal';
import WithMyRates from 'pages/Shipments/ActionForms/CreateShipment/CreateShipmentWithMyRatesModal';
import CreateShipmentAndPrint from 'pages/Shipments/ActionForms/CreateShipmentAndPrint';
import AddOrderForm from 'pages/Shipments/Shipments/OrderForm/AddOrderForm';
import EditOrderForm from 'pages/Shipments/Shipments/OrderForm/EditOrderForm';
import ViewOrderForm from 'pages/Shipments/Shipments/OrderForm/ViewOrderForm';
import FeasibilityRuleForm from 'pages/ShippingOtomation/FeasibilityRules/FeasibilityRuleForm';
import PriorityRulesForm from 'pages/ShippingOtomation/PriorityRules/PriorityRuleForm';
import CityForm from 'pages/SupportAdmin/AddressManagement/Forms/CityForm';
import CountryForm from 'pages/SupportAdmin/AddressManagement/Forms/CountryForm';
import DistrictForm from 'pages/SupportAdmin/AddressManagement/Forms/DistrictForm';
import GovernorateForm from 'pages/SupportAdmin/AddressManagement/Forms/GovernorateForm';
import NeighbourhoodForm from 'pages/SupportAdmin/AddressManagement/Forms/NeighbourhoodForm';
import StateForm from 'pages/SupportAdmin/AddressManagement/Forms/StateForm';
import SupportRequestAccessForm from 'pages/SupportAdmin/ClientUsers/SupportRequestAccessForm';
import ChargeAccountModal from 'pages/Topbar/ChargeAccount/ChargeAccountModal';
import ModifyRolesModal from 'pages/Users/ModifyRolesModal';
import UserForm from 'pages/Users/UserForm';
import BinForm from 'pages/WMSModule/Configuration/Bins/BinForm';
import WHUserForm from 'pages/WMSModule/Configuration/Users/WHUsersForm';
import ZoneForm from 'pages/WMSModule/Configuration/Zones/ZoneForm';
import InventoryForm from 'pages/WMSModule/Inventory/Inventory/InventoryForm';
import InventoryOrderForm from 'pages/WMSModule/Operations/InventoryOrders/InventoryOrderForm';
import PackingPilotForm from 'pages/WMSModule/Operations/Packing/PackingPilotForm';
import EasyputForm from 'pages/WMSModule/Operations/Putaway/EasyputForm';
import PutawayForm from 'pages/WMSModule/Operations/Putaway/PutawayForm';
import WaveCreationPilotModal from 'pages/WMSModule/Operations/Waves/WaveCreationPilotModal';
import WaveForm from 'pages/WMSModule/Operations/Waves/WaveForm';
import WavePickingForm from 'pages/WMSModule/Operations/Waves/WavePickingForm';
import PurchaseOrderForm from 'pages/WMSModule/PurchaseOrders/PurchaseOrderForm';
import PackingForm from 'pages/WarehouseUser/WHPacking/PackingForm/PackingForm';
import WarehouseForm from 'pages/Warehouses/WarehouseForm';

import { addModal, updateModal } from 'stores/modalsSlice';

const ModalRoutes = () => {
	const Modals = useMemo(
		() => ({
			'role-modal': RoleModal,
			'role-tree': RoleTreeModal,
			'role-templates-modal': RoleTemplatesModal,
			'modify-roles-modal': ModifyRolesModal,
			'update-multiple-role-modal': UpdateMultipleRoleModal,
			'update-multiple-module-modal': UpdateMultipleModuleModal,
			'update-multiple-countries-modal': UpdateMultipleCountriesModal,
			'action-role-modal': ActionRoleModal,
			'create-shipment-bulk-aggregator': CreateShipmentBulkAggregatorModal,
			'create-shipment-my-rates': WithMyRates,
			'create-shipment-and-print': CreateShipmentAndPrint,
			'create-return-shipment-aggregator': CreateReturnShipmentAggregator,
			'create-return-shipment-with-my-rates': CreateReturnShipmentWithMyRates,
			'user-form': UserForm,
			'warehouse-form': WarehouseForm,
			'driver-form': DriverForm,
			'driver-track-form': DriverTrackForm,
			'driver-transaction-form': AddTransactionForm,
			'branch-form': BranchForm,
			'product-form': ProductForm,
			'product-attribute-form': ProductAttributesForm,
			'attributes-group-form': AttributesGroupForm,
			'add-order-form': AddOrderForm,
			'edit-order-form': EditOrderForm,
			'view-order-form': ViewOrderForm,
			'box-form': BoxForm,
			'charge-account-form': ChargeAccountModal,
			'reason-config-form': ReasonConfigForm,
			'area-settings-form': AreaSettingForm,
			'shipping-price-form': AddPriceForm,
			'blacklisted-customer-form': BlacklistedCustomerForm,
			'city-group-form': CityGroupForm,
			'email-accounts-form': EmailAccountForm,
			'email-settings-form': EmailSettingForm,
			'feasibility-rule-form': FeasibilityRuleForm,
			'priority-rules-form': PriorityRulesForm,
			'order-otomation-form': OrderOtomationForm,
			'sms-settings-form-modal': SMSSettingForm,
			'free-tracking-sms-form-modal': FreeTrackingSmsForm,
			'customizable-page-form': CustomizablePageForm,
			'brand-form': BrandForm,
			'inventory-form': InventoryForm,
			'inventory-order-form': InventoryOrderForm,
			'bin-form': BinForm,
			'zone-form': ZoneForm,
			'wave-form': WaveForm,
			'wave-picking-form': WavePickingForm,
			'wms-user-form': WHUserForm,
			'putaway-form': PutawayForm,
			'easyput-form': EasyputForm,
			'packing-form': PackingForm,
			'whatsapp-settings-form': WhatsappSettingForm,
			'whatsapp-template-form': WhatsappTemplateForm,
			'support-request-access': SupportRequestAccessForm,
			'purchase-order-form': PurchaseOrderForm,
			'country-form': CountryForm,
			'state-form': StateForm,
			'governorate-form': GovernorateForm,
			'city-form': CityForm,
			'district-form': DistrictForm,
			'neighbourhood-form': NeighbourhoodForm,
			'packing-pilot-form': PackingPilotForm,
			'automation-form': AutomationForm,
			'product-specs-modal': ProductSpecsModal,
			'cod-report-modal': CODReportModal,
			'predefined-message-form': PredefinedMessageForm,
			'wave-pilot-form': WaveCreationPilotModal,
			'add-import-order-form': AddImportOrderModal,
			'edit-import-order-form': EditImportOrderModal,
			'view-import-order-form': ViewImportOrderModal
		}),
		[]
	);

	const [searchParams] = useSearchParams();
	const dispatch = useDispatch();
	const isUserInit = useSelector((state) => state.user.initialized);
	const [isPending, startTransition] = useTransition();
	const isAuthorized = useAccessControl();
	const modals = useSelector((state) => state.modals);

	const modalContext = useContext(NiceModal.NiceModalContext);

	useEffect(() => {
		if (!isUserInit) {
			return;
		}
		const modalName = searchParams.get('modal');

		if (!isAuthorized(`/modal/${modalName}`) || !Modals[modalName]) {
			return;
		}

		if (modalName) {
			const id = searchParams.get('id') ?? undefined;
			const idsStr = searchParams.get('ids') ?? undefined;
			const ids = idsStr ? idsStr.split(',') : undefined;
			const mode = searchParams.get('mode') ?? undefined;
			const modalID = searchParams.get('modalID') ?? undefined;
			const minimized = searchParams.get('minimized') ?? undefined;

			const name = `${modalName}_${modalID}`;
			if (modals[name]?.visible === false) {
				dispatch(
					updateModal({
						modal: modalName,
						modalID,
						visible: true
					})
				);

				return;
			}

			if (!modalContext[name]) {
				NiceModal.register(name, Modals[modalName]);
			}

			startTransition(() => {
				dispatch(addModal({ modal: modalName, modalID, id, ids, mode, visible: !minimized }));
				NiceModal.show(name, { id, ids, modalName, mode });
			});
		}
	}, [searchParams, isUserInit]);

	return isPending ? <Loading /> : null;
};

export default ModalRoutes;
